import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FieldTableCustomColumnIds from '../../../constants/FieldTableCustomColumnIds';

import ThemeIcons from '../../../theme/Icons';
import ThemeContext from '../../../theme/ThemeContext';

import Icon from '../../misc/Icon';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledTH = styled.div`
  box-sizing: border-box;
  background-color: ${(props) => props.theme.secondaryColor};
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme.fontColorPrimary};
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
  border-right: 1px solid ${(props) => props.theme.borderColor};
  padding: 8px;
  max-width: ${(props) => (props.width !== undefined ? `${props.width}px` : 'initial')};
  min-width: ${(props) => (props.width !== undefined ? `${props.width}px` : 'initial')};
  vertical-align: top;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  svg {
    font-size: 12px;
  }
`;

const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledOperand = styled.span`
  font-weight: 600;
  color: ${(props) => props.theme.fontColorSecondary};
  padding-right: 4px;
`;

const StyledTitle = styled.span`
  display: flex;
  flex: 1;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const StyledIconWrapper = styled.span`
  padding-left: 4px;
  svg {
    font-size: 14px;
  }
`;

const StyledActionsWrapper = styled.span`
  white-space: nowrap;
`;

class TableEditorHeader extends PureComponent {

  static contextType = ThemeContext

  static propTypes = {

    id: PropTypes.string,
    columns: PropTypes.array,

    //Action handlers
    onEdit: PropTypes.func,
    onMoveLeft: PropTypes.func,
    onMoveRight: PropTypes.func,

  }

  render() {

    const {
      id,
      columns,

      //Action handlers
      onMoveLeft,
      onMoveRight,
      onEdit,

    } = this.props;

    const { borderColor, primaryColor } = this.context;

    const columnNodes = columns.map((column, columnIndex) => {

      const isUtilityColumn = (column._id === FieldTableCustomColumnIds.rowMenu || column._id === FieldTableCustomColumnIds.rowNumber);

      const adjustedColumnWidth = 200;
      const columnWidth = isUtilityColumn ? 24 : adjustedColumnWidth;

      const columnEdit = isUtilityColumn ? null : (
        <StyledIconWrapper>
          <Icon
            id={`${id}-${column._id}-table-editor-column-edit`}
            color={borderColor}
            hoverColor={primaryColor}
            icon={ThemeIcons.tableSettings.columnEdit}
            onClick={() => onEdit(column._id)}
          />
        </StyledIconWrapper>
      );

      const columnMoveLeft = isUtilityColumn || columnIndex === 2 ? null : (
        <StyledIconWrapper>
          <Icon
            id={`${id}-${column._id}-table-editor-column-move-left`}
            color={borderColor}
            hoverColor={primaryColor}
            size="lg"
            icon={ThemeIcons.tableSettings.columnMoveLeft}
            onClick={() => onMoveLeft(column._id)}
          />
        </StyledIconWrapper>
      );

      const columnMoveRight = isUtilityColumn || columnIndex === columns.length - 1 ? null : (
        <StyledIconWrapper>
          <Icon
            id={`${id}-${column._id}-table-editor-column-move-right`}
            color={borderColor}
            size="lg"
            hoverColor={primaryColor}
            icon={ThemeIcons.tableSettings.columnMoveRight}
            onClick={() => onMoveRight(column._id)}
          />
        </StyledIconWrapper>
      );

      return (
        <StyledTH
          theme={this.context}
          key={column._id}
          data-testid={`${id}-${column._id}-${columnIndex}-table-editor-column-th`}
          {...{ width: columnWidth }}
        >
          <StyledTitleWrapper>
            {isUtilityColumn ? null : (
              <StyledOperand theme={this.context}>
                {column.operand}
                :
              </StyledOperand>
            )}
            <>
              <StyledTitle>{column.title}</StyledTitle>
              <StyledActionsWrapper>
                {columnMoveLeft}
                {columnMoveRight}
                {columnEdit}
              </StyledActionsWrapper>
            </>
          </StyledTitleWrapper>
        </StyledTH>
      );

    });

    return (
      <StyledRow>
        {columnNodes}
      </StyledRow>
    );

  }

}

export default TableEditorHeader;
